import { useEffect, useState } from 'react';
import { ContentShowProps as Props } from './ContentShow.interface';
import { BackColor, Filter } from 'Interfaces/general.interface';
import CarouselItem from "MiniSiteComponents/Carousel/Carousel.interface";
import Helper from "Interfaces/Helper";
import { LISTS } from './ListNames.Interfaces';

const useContentShowLogic = (props: Props) => {

    const { Title, ComponentId, Query, CurrentPageId, ContentShowType } = props;

    const API_URL = "/api/ContentShow";
    const mediaTypeLG = window.matchMedia("(min-width: 1200px)");

    const BackGround = handleComponentBackgroundColor(props);
    const dir = getComputedStyle(document.documentElement).direction;
    const Link = Helper.convertServerLinkItemToClientLinkItem(props.Link);
    const isCollage = ContentShowType == LISTS.COLLAGE;
    const itemsDisplayByViewType = ContentShowType == LISTS.LIST ? ((Number(props.ItemsNumberInRow) != 7 && Number(props.ItemsNumberInRow) > 0) ? Number(props.ItemsNumberInRow) : 7) : (mediaTypeLG.matches ? 8 : 6);
    const limitOfItems = ContentShowType === LISTS.SQUARES ? (mediaTypeLG.matches ? 30 : 20) : 0;   

    // STATE VARS:
    const [isLightBG, setIsLightBG] = useState<boolean>(BackGround.Type === "light");
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<CarouselItem[]>([]);
    const [itemsCount, setItemsCount] = useState<number>(0);
    const [isShowMore, setIsShowMore] = useState<boolean>(false);
    const [itemsNumberInRow, setItemsNumberInRow] = useState<string>('');
        // Filters
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [filters, setFilters] = useState<Filter[] | null>(null);
    const [filterValues, setFilterValues] = useState<string[]>(["", "", "", "", ""]);
        // Pagination
    const [renewPageNumber, setRenewPageNumber] = useState<boolean>(false);
    const [startPage, setStartPage] = useState<number>(0);
    const [endPage, setEndPage] = useState<number>(20);

    // Functions:
    function handleComponentBackgroundColor(props: Props) {

        const propsBackColor: string | undefined = props.BackColor;
        const ContentShowType: string = props.ContentShowType;
        const defaultBGColor: BackColor = { Color: { id: 1, label: "FFFFFF", value: "#FFFFFF" }, Type: "light" };
        let BackGround: BackColor = propsBackColor ? JSON.parse(propsBackColor) : defaultBGColor;

        const isCircles = ContentShowType === LISTS.CIRCLES;
        const isCollage = ContentShowType == LISTS.COLLAGE;
        const isDefaultCurrentBackColorValue = BackGround.Color.value == "#FFFFFF";
        const isMessageBoardExceptionColor = ContentShowType == LISTS.MESSAGES && isDefaultCurrentBackColorValue;

        if (isCollage || isCircles || isMessageBoardExceptionColor) {
            const colorValue = "#FFFFFF";
            BackGround = { Color: { id: 1, label: colorValue, value: colorValue }, Type: "light" };
        }

        return BackGround;

    }

    const setFocusOnLastItem = () => {

        const listEl = document.getElementById("mst-content-list-" + ComponentId);
        
        if (listEl) {
            const listItems = listEl.children;
            listItems.item(itemsDisplayByViewType).classList.remove("d-none");
            listItems.item(itemsDisplayByViewType).setAttribute("tabindex", "0");
            (listItems.item(itemsDisplayByViewType) as HTMLElement)?.focus();
        }

    }

    const changeShowMore = () => {

        if (!isShowMore) {
            Helper.handleLinkClicksGA4(ContentShowType, Title, "more items");
        }

        setIsShowMore(!isShowMore);

        setFocusOnLastItem();
    }

    const getItems = async (searchword: string, filterValues: string[], startPage: number = 0) => {

        type ResponseType = { results: CarouselItem[], totalCount: number, filterLists: Filter[] };

        try {

            const queryParams = {
                API_URL,
                queryId: Query,
                pageId: CurrentPageId,
                skip: startPage,
                limit: limitOfItems || 0,
                searchTerm: searchword,
                includedFilters: filterValues.map(filter => ({ isActive: !!filter, SelectedValue: filter }))
            };

            const response: Partial<ResponseType> = await Helper.fetchData(queryParams);

            setItems(response?.results || []);
            setItemsCount(response?.totalCount || 0);
            setFilters(response?.filterLists || null);
            setSearchTerm(searchword);
            setFilterValues([...filterValues]);
            setIsLoaded(true);


        }
        catch (err) { setIsLoaded(false); }

    }

    const searchCallback = async (searchTerm: string, filterValues: string[]) => {

        setRenewPageNumber(true);

        await getItems(searchTerm, filterValues);

    }
    // For page pagination
    const pagerCallback = (startFrom: number, lastPage: number) => {

        setStartPage(startFrom);
        setEndPage(lastPage);
        setRenewPageNumber(false);

        getItems(searchTerm, filterValues, startFrom);

    }


    return {
        VARS: {
            LISTS,
            BackGround,
            dir,
            Link,
            isCollage,
            itemsDisplayByViewType,
            limitOfItems,
            API_URL,
            mediaTypeLG,
            itemsNumberInRow,
        },
        STATE: {
            isLightBG,
            isLoaded,
            items,
            itemsCount,
            isShowMore,
            searchTerm,
            filters,
            filterValues,
            renewPageNumber,
            startPage,
            endPage,
        },
        FUNC: {
            searchCallback,
            getItems,
            setIsLightBG,
            pagerCallback,
            changeShowMore,
        }
    }
}

export default useContentShowLogic;
